interface PlaceholderPageProps {
  title: string;
}

/**
 * Pagina temporaria enquanto a porta 1:1 de cada tela Vue para React
 * ainda esta em andamento. Sera substituida por telas reais, mantendo
 * os mesmos campos/fluxos das paginas originais.
 */
export default function PlaceholderPage({ title }: PlaceholderPageProps) {
  return (
    <div className="rounded-lg bg-white p-8 shadow-sm">
      <h2 className="text-xl font-bold text-slate-800">{title}</h2>
      <p className="mt-2 text-sm text-slate-500">Esta tela ainda está em migração para React.</p>
    </div>
  );
}
